const platform = {
    title: 'プラットフォーム設定',
    subtitle: 'テナント横断の管理者とプラットフォーム全体の外観を管理します。',
    branding_title: 'プラットフォームブランド',
    branding_description: 'コンソール、認証、アカウントセンター、デモ、ヘルプセンターに適用されます。',
    product_name: '製品名',
    slogan: 'スローガン',
    light_logo: 'ライトテーマのロゴ',
    dark_logo: 'ダークテーマのロゴ',
    upload_logo: 'ロゴをアップロード',
    uploading: 'アップロード中…',
    logo_uploaded: 'ロゴをアップロードしました',
    hide_open_source_notice: 'オープンソース表記を非表示',
    hide_open_source_notice_description: '画面上の帰属リンクを非表示にし、必要なライセンスとソースファイルは保持します。',
    save: '変更を保存',
    saving: '保存中…',
    saved: 'ブランドを保存しました',
    administrators_title: 'プラットフォーム管理者',
    administrators_description: 'すべてのテナントとインスタンス設定を管理できます。',
    administrator_identifier_placeholder: 'ユーザー ID、ユーザー名、メール',
    add_administrator: '管理者を追加',
    administrator_added: '管理者を追加しました',
    remove_administrator: '管理者を削除',
};
export default Object.freeze(platform);
